import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserService } from '../../core/api/user.service';
import { LoadingService } from '../../core/services/loading.service';
import { ToastrService } from 'ngx-toastr';
import { CommonModule } from '@angular/common';
import { FileService } from '../../core/api/file.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-profile-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './profile-dialog.component.html',
  styleUrl: './profile-dialog.component.scss',
})
export class ProfileDialogComponent implements OnInit {
  profileData: any;
  imageUrl: any;

  constructor(
    private dialog: MatDialogRef<ProfileDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: UserService,
    private loadingService: LoadingService,
    private toastrService: ToastrService,
    private fileService: FileService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.getProfile();
  }

  getProfile(): void {
    this.loadingService.startLoading();
    this.service
      .getById(this.data)
      .then((res) => {
        this.loadingService.endLoading();
        this.profileData = res;
        if (this.profileData.file) {
          this.loadingService.startLoading();
          this.fileService.download(this.profileData.file.id).subscribe(
            (res: any) => {
              this.loadingService.endLoading();
              this.imageUrl = URL.createObjectURL(res);
            },
            (error) => {
              this.loadingService.endLoading();
            }
          );
        }
      })
      .catch((err) => {
        this.loadingService.endLoading();
        this.toastrService.error('Failed to load profile data', 'Error');
      });
  }

  closeDialog(): void {
    this.dialog?.close();
  }

  setRole(data: any) {
    if (data?.length) {
      return data.map((item: any) => item?.role?.name).join(', ');
    } else {
      return '-';
    }
  }

  viewProfile(id: any): void {
    this.dialog.close();
    this.router.navigate(['dashboard/profile/view'], {
      queryParams: {
        id: id,
      },
    });
  }
}
